<mat-sidenav-container class="help-side-nav" [ngClass]="{'content-hidden': !isVisibleContent}">

    <mat-sidenav #helpsidenav mode="over" position="end" (closedStart)="closeHelpCenter()">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="help-title">
            <h2>Help Center</h2>

            <button mat-icon-button class="close-help-btn" (click)="closeHelpCenter()" tabindex="-1">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <ngc-help></ngc-help>
    </mat-sidenav>

    <mat-sidenav-content>
        <ngc-toolbar-glob [helpCenterAvailable]="helpCenterAvailable"
                          (onToggleMenu)="toggleMenu()"
                          (onOpenHelpCenter)="openHelpCenter()"
        ></ngc-toolbar-glob>

        <div class="menu-side-nav">
            <div id="ngc-main-content" >
                <div id="wrapper">
                    <div class="staticMenu" [ngClass]="{'menu-opened': menuOpened || menuTemporaryOpened}">
                        <ngc-navbar class="ngc-navbar"
                                    (mouseenter)="openTemporaryMenu()"
                                    (mouseleave)="collapseTemporaryOpenedMenu()"
                        ></ngc-navbar>
                    </div>

                    <p class="notification main-notification"
                       [ngClass]="{'slide-sysadm-help-menu': menuOpened,
                                   'warning-msg': passwordExpireDays > 2,
                                   'error-msg': passwordExpireDays < 3}"
                       *ngIf="!(isMainNotificationClosed$ | async) && showPasswordExpirationNotification && (passwordExpireDays > -1)"
                    >
                        <span></span>
                        <span>
                            <mat-icon *ngIf="passwordExpireDays > 2">warning</mat-icon>
                            <mat-icon *ngIf="passwordExpireDays < 3">error</mat-icon>Your password will expire
                            {{passwordExpireDays === 0 ? 'today' : (passwordExpireDays === 1 ? 'in ' + passwordExpireDays + ' day' : 'in ' + passwordExpireDays + ' days')}}.
                            To update it, click <a class="notification-action-link font-weight-500 reset-password-link" routerLink="user/profile/securitySettings">here</a>
                        </span>
                        <button mat-button matSuffix mat-icon-button aria-label="Close" class="close-notification-btn" (click)="onCloseNotification()" type="button">
                            <mat-icon>close</mat-icon>
                        </button>
                    </p>

                    <div class="content-wrapper" [ngClass]="{'slide-sysadm-help-menu': menuOpened,
                                                            'main-notification-closed': (isMainNotificationClosed$ | async),
                                                            'show-password-expiration-notification': !(isMainNotificationClosed$ | async) && showPasswordExpirationNotification && (passwordExpireDays > -1)}"
                    >
                        <div class="ng-content-wrapper">
                            <router-outlet></router-outlet>
                        </div>

                        <ngc-footer-page></ngc-footer-page>
                    </div>
                </div>
            </div>
        </div>


    </mat-sidenav-content>

</mat-sidenav-container>


<div *ngIf="!isVisibleContent && isCheckingClaimsForAuthentication" class="spinner-container">
    <mat-progress-spinner
        [color]="'accent'"
        [diameter]="50"
        [mode]="'indeterminate'">
    </mat-progress-spinner>
</div>
